import api from './api';

export const adminService = {
  // === GESTION DES UTILISATEURS ===
  
  getUsers: async (params = {}) => {
    const response = await api.get('/admin/users', { params });
    return response.data;
  },

  getUser: async (id) => {
    const response = await api.get(`/admin/users/${id}`);
    return response.data;
  },

  createUser: async (userData) => {
    const response = await api.post('/admin/users', userData);
    return response.data;
  },

  updateUser: async (id, userData) => {
    const response = await api.put(`/admin/users/${id}`, userData);
    return response.data;
  },

  blockUser: async (id, isBlocked) => {
    const response = await api.patch(`/admin/users/${id}/block`, { isBlocked });
    return response.data;
  },

  approveUser: async (id, isApproved) => {
    const response = await api.patch(`/admin/users/${id}/approve`, { isApproved });
    return response.data;
  },

  deleteUser: async (id) => {
    const response = await api.delete(`/admin/users/${id}`);
    return response.data;
  },

  getPendingApprovals: async () => {
    const response = await api.get('/admin/pending-approvals');
    return response.data;
  },

  // === GESTION DES BOUTIQUES ===
  
  getBoutiques: async (params = {}) => {
    const response = await api.get('/admin/boutiques', { params });
    return response.data;
  },

  getBoutique: async (id) => {
    const response = await api.get(`/admin/boutiques/${id}`);
    return response.data;
  },

  createBoutique: async (boutiqueData) => {
    const response = await api.post('/admin/boutiques', boutiqueData);
    return response.data;
  },

  updateBoutique: async (id, boutiqueData) => {
    const response = await api.put(`/admin/boutiques/${id}`, boutiqueData);
    return response.data;
  },

  updateBoutiqueStatus: async (id, isActive) => {
    const response = await api.patch(`/admin/boutiques/${id}/status`, { isActive });
    return response.data;
  },

  deleteBoutique: async (id) => {
    const response = await api.delete(`/admin/boutiques/${id}`);
    return response.data;
  },

  // === GESTION DES PRODUITS ===
  
  getProducts: async (params = {}) => {
    const response = await api.get('/admin/products', { params });
    return response.data;
  },

  getProduct: async (id) => {
    const response = await api.get(`/admin/products/${id}`);
    return response.data;
  },

  createProduct: async (productData) => {
    // S'assurer que les champs correspondent au backend
    const formattedData = {
      ...productData,
      stockQuantity: productData.stock || 0,
      images: productData.images || [],
      categorieId: productData.categorieId || null,
      isActive: productData.isActive !== false
    };
    const response = await api.post('/admin/products', formattedData);
    return response.data;
  },

  updateProduct: async (id, productData) => {
    // S'assurer que les champs correspondent au backend
    const formattedData = {
      ...productData,
      stockQuantity: productData.stock || 0,
      images: productData.images || [],
      categorieId: productData.categorieId || null,
      isActive: productData.isActive !== false
    };
    const response = await api.put(`/admin/products/${id}`, formattedData);
    return response.data;
  },

  updateProductStatus: async (id, isActive) => {
    const response = await api.patch(`/admin/products/${id}/status`, { isActive });
    return response.data;
  },

  updateProductAvailability: async (id, isAvailable) => {
    const response = await api.patch(`/admin/products/${id}/availability`, { isAvailable });
    return response.data;
  },

  updateProductVip: async (id, isVip) => {
    const response = await api.patch(`/admin/products/${id}/vip`, { isVip });
    return response.data;
  },

  deleteProduct: async (id) => {
    const response = await api.delete(`/admin/products/${id}`);
    return response.data;
  },

  // === GESTION DES LOGOS DE BOUTIQUES ===
  
  uploadBoutiqueLogo: async (logoFile) => {
    const formData = new FormData();
    formData.append('logo', logoFile);
    
    const response = await api.post('/admin/boutiques/upload-logo', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteBoutiqueLogo: async (filename) => {
    const response = await api.delete(`/admin/boutiques/logo/${filename}`);
    return response.data;
  },

  cleanupBoutiqueLogos: async () => {
    const response = await api.post('/admin/boutiques/cleanup-logos');
    return response.data;
  },

  // === GESTION DES IMAGES DE PRODUITS ===
  
  uploadProductImages: async (imageFiles) => {
    const formData = new FormData();
    imageFiles.forEach((file, index) => {
      formData.append('images', file);
    });
    
    const response = await api.post('/admin/products/upload-images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  uploadServiceImages: async (imageFiles) => {
    const formData = new FormData();
    imageFiles.forEach((file, index) => {
      formData.append('images', file);
    });
    
    const response = await api.post('/admin/services/upload-images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteProductImage: async (filename) => {
    const response = await api.delete(`/admin/products/image/${filename}`);
    return response.data;
  },

  cleanupProductImages: async () => {
    const response = await api.post('/admin/products/cleanup-images');
    return response.data;
  },

  // === GESTION DES ANNONCES ===
  
  getAds: async (params = {}) => {
    const response = await api.get('/admin/ads', { params });
    return response.data;
  },

  getAd: async (id) => {
    const response = await api.get(`/admin/ads/${id}`);
    return response.data;
  },

  createAd: async (adData) => {
    const response = await api.post('/admin/ads', adData);
    return response.data;
  },

  updateAd: async (id, adData) => {
    const response = await api.put(`/admin/ads/${id}`, adData);
    return response.data;
  },

  deleteAd: async (id) => {
    const response = await api.delete(`/admin/ads/${id}`);
    return response.data;
  },

  toggleAdStatus: async (id, isActive) => {
    const response = await api.patch(`/admin/ads/${id}/toggle`, { isActive });
    return response.data;
  },

  // === GESTION DES IMAGES D'ANNONCES ===
  
  uploadAdImages: async (imageFiles) => {
    const formData = new FormData();
    imageFiles.forEach((file) => {
      formData.append('images', file);
    });
    
    const response = await api.post('/admin/ads/upload-images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteAdImage: async (filename) => {
    const response = await api.delete(`/admin/ads/image/${filename}`);
    return response.data;
  },

  cleanupAdImages: async () => {
    const response = await api.post('/admin/ads/cleanup-images');
    return response.data;
  },

  // === GESTION DES VIDÉOS D'ANNONCES ===
  
  uploadAdVideo: async (videoFile) => {
    const formData = new FormData();
    formData.append('video', videoFile);
    
    const response = await api.post('/admin/ads/upload-video', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteAdVideo: async (filename) => {
    const response = await api.delete(`/admin/ads/video/${filename}`);
    return response.data;
  },

  // === STATISTIQUES ===
  
  getStats: async () => {
    const response = await api.get('/admin/stats');
    return response.data;
  },

  // === GESTION DES APPROBATIONS ===
  
  getApprovalSettings: async () => {
    const response = await api.get('/admin/approval-settings');
    return response.data;
  },

  updateApprovalSettings: async (settings) => {
    const response = await api.put('/admin/approval-settings', settings);
    return response.data;
  },

  // === GESTION DES PARAMÈTRES SYSTÈME ===
  
  getSystemSettings: async () => {
    const response = await api.get('/admin/system-settings');
    return response.data;
  },

  getSystemSetting: async (key) => {
    const response = await api.get(`/admin/system-settings/${key}`);
    return response.data;
  },

  updateSystemSetting: async (key, value) => {
    const response = await api.put(`/admin/system-settings/${key}`, { value });
    return response.data;
  },

  deleteSystemSetting: async (key) => {
    const response = await api.delete(`/admin/system-settings/${key}`);
    return response.data;
  },

  // === GESTION DES CATÉGORIES DE SERVICES ===

  getCategorieServices: async (params = {}) => {
    const response = await api.get('/admin/categorie-services', { params });
    return response.data;
  },

  getCategorieService: async (id) => {
    const response = await api.get(`/admin/categorie-services/${id}`);
    return response.data;
  },

  createCategorieService: async (categorieData) => {
    const response = await api.post('/admin/categorie-services', categorieData);
    return response.data;
  },

  updateCategorieService: async (id, categorieData) => {
    const response = await api.put(`/admin/categorie-services/${id}`, categorieData);
    return response.data;
  },

  deleteCategorieService: async (id) => {
    const response = await api.delete(`/admin/categorie-services/${id}`);
    return response.data;
  },

  toggleCategorieServiceStatus: async (id) => {
    const response = await api.patch(`/admin/categorie-services/${id}/toggle-statut`);
    return response.data;
  },

  // === GESTION DES SERVICES ===

  getServices: async (params = {}) => {
    const response = await api.get('/admin/services', { params });
    return response.data;
  },

  getService: async (id) => {
    const response = await api.get(`/admin/services/${id}`);
    return response.data;
  },

  createService: async (serviceData) => {
    const response = await api.post('/admin/services', serviceData);
    return response.data;
  },

  updateService: async (id, serviceData) => {
    const response = await api.put(`/admin/services/${id}`, serviceData);
    return response.data;
  },

  deleteService: async (id) => {
    const response = await api.delete(`/admin/services/${id}`);
    return response.data;
  },

  updateServiceStatus: async (id, statusData) => {
    const response = await api.patch(`/admin/services/${id}/status`, statusData);
    return response.data;
  },

  // === GESTION DES LOGS DE SÉCURITÉ ===
  
  getSecurityKPI: async () => {
    const response = await api.get('/admin/security/kpi');
    return response.data;
  },

  getLoginAttempts: async (params = {}) => {
    const response = await api.get('/admin/security/login-attempts', { params });
    return response.data;
  },

  getSecurityEvents: async (params = {}) => {
    const response = await api.get('/admin/security/events', { params });
    return response.data;
  },

  // === GESTION DES AVIS ===
  
  getReviews: async (params = {}) => {
    const response = await api.get('/admin/reviews', { params });
    return response.data;
  },

  getReview: async (id) => {
    const response = await api.get(`/admin/reviews/${id}`);
    return response.data;
  },

  approveReview: async (id) => {
    const response = await api.put(`/admin/reviews/${id}/approve`);
    return response.data;
  },

  rejectReview: async (id) => {
    const response = await api.put(`/admin/reviews/${id}/reject`);
    return response.data;
  },

  deleteReview: async (id) => {
    const response = await api.delete(`/admin/reviews/${id}`);
    return response.data;
  }
};
